import { TShortAccount, TShortAccountSelected, TShortSubAccountSelected } from './types';

export const selectAllSubAccounts = (
  subAccounts: TShortSubAccountSelected[],
  value: boolean
): TShortSubAccountSelected[] => {
  return Array.isArray(subAccounts) ? subAccounts.map((subAccount) => ({ ...subAccount, selected: value })) : null;
};

const getSubAccountsIds = (account: TShortAccount, data: TShortAccount[]) => {
  if (!Array.isArray(account.subAccounts)) {
    return [];
  }
  return account.subAccounts.length
    ? account.subAccounts.map((subAccount) => subAccount.id)
    : data.find((dataAccount) => dataAccount.id === account.id).subAccounts.map((subAccount) => subAccount.id);
};

const getSelectedIds = (selectedData: TShortAccount[], data: TShortAccount[]): string[] =>
  Array.isArray(selectedData) && selectedData.length
    ? selectedData
        .map((account) => {
          const idsSubAccounts = getSubAccountsIds(account, data);

          return [account.id, ...idsSubAccounts];
        })
        .flat()
    : [];

export const addSelectKey = (data: TShortAccount[], selectedData: TShortAccount[]): TShortAccountSelected[] => {
  const ids = getSelectedIds(selectedData, data);

  return data.map((account) => {
    const formattedSubAccounts = Array.isArray(account.subAccounts)
      ? account.subAccounts.map((subAccount) => ({ ...subAccount, selected: ids.includes(subAccount.id) }))
      : null;
    return { ...account, subAccounts: formattedSubAccounts, selected: ids.includes(account.id) };
  });
};

export const filterSelectedAccounts = (data: TShortAccountSelected[]): TShortAccount[] =>
  data
    .map((account) => {
      const formattedSubAccounts = Array.isArray(account.subAccounts)
        ? account.subAccounts
            .filter((subAccounts) => subAccounts.selected)
            .map((subAccount) => ({
              accountName: subAccount.accountName,
              id: subAccount.id,
              subAccounts: subAccount.subAccounts
            }))
        : null;

      const isAccountSelected = account.selected || (formattedSubAccounts !== null && formattedSubAccounts.length);
      return isAccountSelected
        ? { accountName: account.accountName, id: account.id, subAccounts: formattedSubAccounts }
        : null;
    })
    .filter((account) => account !== null);
